export default "__VITE_ASSET__BvFvQhn8__"